import qs from 'qs';
import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRelatedBlogsBySlug = async (slug, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data: blogs, total },
  } = await axios.get(`/api/public/companies/${slug}/blogs?${queryString}`);

  return { blogs, total };
};

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  includeInactive: false,
  sortBy: 'dateCreated',
  queryKey: ['companies-related-blogs-by-slug'],
  queryOptions: {},
};

export const useGetRelatedBlogsBySlug = (slug, queryParams = {}) => {
  const { page, limit, search, includeInactive, sortBy, queryKey, queryOptions } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    sortby: sortBy,
    offset: page * limit,
  };

  return useQuery(
    [...queryKey, slug],
    () => getRelatedBlogsBySlug(slug, queryStringParams),
    {
      select: ({ blogs, total }) => ({ blogs, total }),
      initialData: { blogs: [], total: 0 },
      ...queryOptions,
    }
  );
};